import Keycloak from "keycloak-js";

let keycloak:Keycloak;

// Initialize Keycloak client-side
if (typeof window !== "undefined") {
keycloak = new Keycloak({
        clientId: "mobile",
        url: "https://auth.teclaverde.com",
        realm: "iotverde",
});
}
export  {keycloak};
